module.exports = __webpack_public_path__ + "static/media/1015873.87cff652.png";